<template>
  <div>
    <ControlPanel :title="'Раздел: Банк'" :icon="'mdi mdi-folder'" :links="links">
    </ControlPanel>
    <div class="container-fluid">
      <Category>
        <template v-slot:pos1>
          <p>В этом разделе вы можете сформировать банковские документы в формате SWIFT для импорта в банковские сервисы.</p>
        </template>

        <template v-slot:pos2>
          <table class="table table-sm table-bordered">
            <tr>
              <td><b-link to="/bank/swift/">Формирование файлов SWIFT</b-link></td>
            </tr>
          </table>
        </template>
      </Category>
    </div>
  </div>
</template>

<script>
import ControlPanel from "@/components/base/ControlPanel";
import Category from "@/components/base/Category";

export default {
  name: 'BankDefault',
  components: {
    ControlPanel,
    Category
  },
  data: function () {
    return {
      links: [
        {name: 'Зарплата', link: '/salary/', icon: 'mdi mdi-credit-card-check-outline'},
        {name: 'Справочники', link: '/registers/', icon: 'mdi mdi-list-box'},
        {name: 'Документы', link: '/docs/', icon: 'mdi mdi-file'},
        {name: 'Банк', link: '/bank/', icon: 'mdi mdi-bank'},
        {name: 'Отчёты', link: '/reports/', icon: 'mdi mdi-chart-bar'},
      ]
    }
  }
}
</script>

<style scoped>

</style>